import { OrganisationPermission } from './OrganisationPermission';

export class ACL {
  can_niaga: boolean;
  can_receive_payment: boolean;
  organisation_permissions: OrganisationPermission[];

  constructor(data: any) {
    this.can_niaga = data.can_niaga ?? false;
    this.can_receive_payment = data.can_receive_payment ?? false;
    this.organisation_permissions = data.organisation_permissions?.map(
      (perm: any) => OrganisationPermission.build(perm)
    ) || [];
  }

  canNiaga(): boolean {
    return this.can_niaga;
  }

  canReceivePayment(): boolean {
    return this.can_receive_payment;
  }

  hasOrganisationPermission(orgId: number): OrganisationPermission | undefined {
    return this.organisation_permissions.find(
      perm => perm.organisation_id === orgId && perm.isActive()
    );
  }

  canWriteBid(orgId: number): boolean {
    const perm = this.hasOrganisationPermission(orgId);
    return perm?.canWriteBid() ?? false;
  }

  canReadBid(orgId: number): boolean {
    const perm = this.hasOrganisationPermission(orgId);
    return perm?.canReadBid() ?? false;
  }

  canWriteEmployee(orgId: number): boolean {
    const perm = this.hasOrganisationPermission(orgId);
    return perm?.canWriteEmployee() ?? false;
  }

  static build(data: any): ACL {
    return new ACL(data);
  }
}
